import { render, staticRenderFns } from "./TodoNameSelect.vue?vue&type=template&id=54f3453c&"
import script from "./TodoNameSelect.vue?vue&type=script&lang=js&"
export * from "./TodoNameSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports